// extracted by mini-css-extract-plugin
export var lazyImage = "lazyImage-module--lazyImage--hGVKi";
export var fitSize = "lazyImage-module--fitSize--xRAT4";